import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { globalStateSelector } from 'store/selector';
import { CallBreakTheme } from 'modules/theme'
import { messageAction, globalAction } from 'store/action';
export class CallBreak extends Component {
  sendMessage(message) {
    const { emitSocketMessage } = this.props;
    emitSocketMessage('message-processor', message);
  }
  render() {
    const { breakList, updatePause } = this.props
    return (
      <CallBreakTheme
        breakList={breakList}
        onSelect={( data )=>{
          console.log("data", data);
          let message = {
            type: 'stateHandler',
            state: "break",
            subState: data.name,
            stateInfo: {
              id : data._id,
              name : data.name
            }
          };
          this.sendMessage(message);
          updatePause({ key: 'breakName', value: data.name }  )
        }}
      />
    )
  }
}


const stateToProps = state => ({
  breakList: globalStateSelector.getDynamic(state, { key: 'breakList' })
});

const dispatchToProps = dispatch => ({
  emitSocketMessage: (type, messageData) => {
    dispatch(messageAction.emitSocketMessage(type, messageData));
  },
  updatePause( data ){
    dispatch(globalAction.dynamicUpdate({data}));
  }
});
export default connect(stateToProps, dispatchToProps)(CallBreak);


// WEBPACK FOOTER //
// src/dialpad/components/layout/CallBreak.js